/* DV storefront RUM - source artifact only; release dv_observe_20260817_1. */
(function () {
  'use strict';

  var ENDPOINT = 'https://dolcevita-massimo.ngrok.io/api/tracking/public/telemetry';
  var RELEASE = 'dv_observe_20260817_1';
  if (window.__DV_STOREFRONT_RUM_OWNER__) return;
  try {
    Object.defineProperty(window, '__DV_STOREFRONT_RUM_OWNER__', {
      value: RELEASE,
      configurable: false,
      enumerable: false,
      writable: false
    });
  } catch (_) {
    window.__DV_STOREFRONT_RUM_OWNER__ = RELEASE;
  }
  var originalFetch = typeof window.fetch === 'function' ? window.fetch.bind(window) : null;
  var themeCandidate = window.Shopify && window.Shopify.theme && String(window.Shopify.theme.id || '');
  var THEME = /^[A-Za-z0-9._:-]{1,64}$/.test(themeCandidate) ? themeCandidate : 'unknown';
  var sessionId = randomId();

  function analyticsAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return Boolean(
        privacy &&
        typeof privacy.analyticsProcessingAllowed === 'function' &&
        privacy.analyticsProcessingAllowed() === true
      );
    } catch (_) {
      return false;
    }
  }

  function pathCategory(pathname) {
    var path = String(pathname || '').toLowerCase();
    if (path === '' || path === '/') return 'home';
    if (/^\/collections(?:\/|$)/.test(path)) return 'collection';
    if (/^\/products(?:\/|$)/.test(path)) return 'product';
    if (/^\/cart(?:\/|$)/.test(path)) return 'cart';
    if (/^\/search(?:\/|$)/.test(path)) return 'search';
    if (/^\/(?:checkouts?|orders)(?:\/|$)/.test(path)) return 'checkout';
    if (/^\/account(?:\/|$)/.test(path)) return 'account';
    if (/^\/pages(?:\/|$)/.test(path)) return 'page';
    if (/^\/policies(?:\/|$)/.test(path)) return 'policy';
    return 'other';
  }

  function sameSiteCategory(input) {
    try {
      var candidate = typeof input === 'string' ? input : (input && input.url);
      var parsed = new URL(candidate || window.location.href, window.location.href);
      if (parsed.origin !== window.location.origin) return null;
      return pathCategory(parsed.pathname);
    } catch (_) {
      return null;
    }
  }

  function highIntentClientFailure(category, status) {
    return (category === 'cart' || category === 'checkout') && status >= 400 && status < 500;
  }

  function fingerprint(value) {
    var input = String(value || '').slice(0, 256);
    var hash = 2166136261;
    for (var i = 0; i < input.length; i += 1) {
      hash ^= input.charCodeAt(i);
      hash = Math.imul(hash, 16777619);
    }
    return (hash >>> 0).toString(16).padStart(8, '0');
  }

  function randomId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'dvrum_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 18);
  }

  function emit(kind, errorCode, signal, category) {
    if (!originalFetch || !analyticsAllowed()) return;
    var body = {
      v: 1,
      c: '1',
      event: kind,
      eventId: randomId(),
      theme: THEME,
      release: RELEASE,
      pathCategory: category || pathCategory(window.location.pathname),
      errorCode: errorCode,
      errorFingerprint: fingerprint(kind + '|' + errorCode + '|' + String(signal || '')),
      sessionId: sessionId
    };
    try {
      var delivery = originalFetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        keepalive: true,
        credentials: 'omit'
      });
      if (delivery && typeof delivery.catch === 'function') {
        delivery.catch(function () {});
      }
    } catch (_) {}
  }

  window.addEventListener('error', function (event) {
    if (event && event.target && event.target !== window && (event.target.src || event.target.href)) {
      var category = sameSiteCategory(event.target.src || event.target.href);
      if (category) emit('network_error', 'resource_error', event.target.tagName || 'resource', category);
      return;
    }
    var name = event && event.error && event.error.name;
    // Error messages can contain email, query values or form contents. Only a
    // bounded error class contributes to the persisted fingerprint.
    emit('browser_error', 'js_error', String(name || 'Error').slice(0, 64), null);
  }, true);

  window.addEventListener('unhandledrejection', function (event) {
    var reason = event && event.reason;
    var name = reason && reason.name;
    emit('unhandled_rejection', 'promise_rejection', String(name || 'Error').slice(0, 64), null);
  });

  if (originalFetch) {
    try {
      window.fetch = function () {
        var args = Array.prototype.slice.call(arguments);
        var category = sameSiteCategory(args[0]);
        return originalFetch.apply(window, args).then(function (response) {
          if (category && response && response.status >= 500) {
            emit('network_error', 'fetch_5xx', String(response.status), category);
          } else if (category && response && highIntentClientFailure(category, response.status)) {
            emit('network_error', 'fetch_4xx', String(response.status), category);
          }
          return response;
        }).catch(function (error) {
          if (category) emit('network_error', 'fetch_rejected', error && error.name || 'Error', category);
          throw error;
        });
      };
    } catch (_) {}
  }

  if (
    window.XMLHttpRequest &&
    window.XMLHttpRequest.prototype &&
    typeof window.XMLHttpRequest.prototype.open === 'function' &&
    typeof window.XMLHttpRequest.prototype.send === 'function'
  ) {
    var originalOpen = window.XMLHttpRequest.prototype.open;
    var originalSend = window.XMLHttpRequest.prototype.send;
    try {
      window.XMLHttpRequest.prototype.open = function (method, target) {
        this.__dvRumCategory = sameSiteCategory(target);
        return originalOpen.apply(this, arguments);
      };
      window.XMLHttpRequest.prototype.send = function () {
        var request = this;
        if (request.__dvRumCategory) {
          var requestCategory = request.__dvRumCategory;
          var onDvRumLoadEnd = function () {
            request.removeEventListener('loadend', onDvRumLoadEnd);
            if (request.status >= 500) {
              emit('network_error', 'xhr_5xx', String(request.status), requestCategory);
            } else if (highIntentClientFailure(requestCategory, request.status)) {
              emit('network_error', 'xhr_4xx', String(request.status), requestCategory);
            } else if (request.status === 0) {
              emit('network_error', 'xhr_failed', 'status_0', requestCategory);
            }
          };
          request.addEventListener('loadend', onDvRumLoadEnd);
        }
        return originalSend.apply(this, arguments);
      };
    } catch (_) {}
  }
})();
